import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Store scroll positions for each pathname
const scrollPositions = new Map();

export default function ScrollToTop() {
  const { pathname, key } = useLocation();
  const navigationType = useNavigationType();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    const mainContent = document.querySelector('.main-content');
    if (!mainContent) {
      return;
    }

    if (previousPathname.current !== pathname) {
      scrollPositions.set(previousPathname.current, mainContent.scrollTop);
    }

    if (navigationType === 'POP') {
      const savedPosition = scrollPositions.get(pathname);

      if (savedPosition !== undefined) {
        setTimeout(() => {
          mainContent.scrollTop = savedPosition;
        }, 50);
      } else {
        mainContent.scrollTop = 0;
      }
    } else {
      mainContent.scrollTop = 0;
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }

    previousPathname.current = pathname;
  }, [key, navigationType, pathname]);

  return null;
}
